export const WIDTH_INSPECTOR = 300;
